// extracted by mini-css-extract-plugin
module.exports = {"input":"input_input__3iLJ4","select":"input_select__3Ps9_"};